'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _axwayReactIntl = require('axway-react-intl');

var _axwayReactIntl2 = _interopRequireDefault(_axwayReactIntl);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HTTPResponseLabel = function (_React$Component) {
	_inherits(HTTPResponseLabel, _React$Component);

	function HTTPResponseLabel(props) {
		_classCallCheck(this, HTTPResponseLabel);

		var _this = _possibleConstructorReturn(this, (HTTPResponseLabel.__proto__ || Object.getPrototypeOf(HTTPResponseLabel)).call(this, props));

		_axwayReactIntl2.default.init(_this);
		return _this;
	}

	_createClass(HTTPResponseLabel, [{
		key: '_getCodes',
		value: function _getCodes() {
			return {
				default: '', // say nothing
				100: this.intl.formatMsg('Continue', 'http_100'),
				101: this.intl.formatMsg('Switching Protocols', 'http_101'),
				102: this.intl.formatMsg('Processing', 'http_102'),
				200: this.intl.formatMsg('OK', 'http_200'),
				201: this.intl.formatMsg('Created', 'http_201'),
				202: this.intl.formatMsg('Accepted', 'http_202'),
				203: this.intl.formatMsg('Non-Authoritative Information', 'http_203'),
				204: this.intl.formatMsg('No Content', 'http_204'),
				205: this.intl.formatMsg('Reset Content', 'http_205'),
				206: this.intl.formatMsg('Partial Content', 'http_206'),
				207: this.intl.formatMsg('Multi-Status', 'http_207'),
				300: this.intl.formatMsg('Multiple Choices', 'http_300'),
				301: this.intl.formatMsg('Moved Permanently', 'http_301'),
				302: this.intl.formatMsg('Found', 'http_302'),
				303: this.intl.formatMsg('See Other', 'http_303'),
				304: this.intl.formatMsg('Not Modified', 'http_304'),
				305: this.intl.formatMsg('Use Proxy', 'http_305'),
				306: this.intl.formatMsg('Switch Proxy', 'http_306'),
				307: this.intl.formatMsg('Temporary Redirect', 'http_307'),
				400: this.intl.formatMsg('Bad Request', 'http_400'),
				401: this.intl.formatMsg('Unauthorized', 'http_401'),
				402: this.intl.formatMsg('Payment Required', 'http_402'),
				403: this.intl.formatMsg('Forbidden', 'http_403'),
				404: this.intl.formatMsg('Not Found', 'http_404'),
				405: this.intl.formatMsg('Method Not Allowed', 'http_405'),
				406: this.intl.formatMsg('Not Acceptable', 'http_406'),
				407: this.intl.formatMsg('Proxy Authentication Required', 'http_407'),
				408: this.intl.formatMsg('Request Timeout', 'http_408'),
				409: this.intl.formatMsg('Conflict', 'http_409'),
				410: this.intl.formatMsg('Gone', 'http_410'),
				411: this.intl.formatMsg('Length Required', 'http_411'),
				412: this.intl.formatMsg('Precondition Failed', 'http_412'),
				413: this.intl.formatMsg('Request Entity Too Large', 'http_413'),
				414: this.intl.formatMsg('Request-URI Too Long', 'http_414'),
				415: this.intl.formatMsg('Unsupported Media Type', 'http_415'),
				416: this.intl.formatMsg('Requested Range Not Satisfiable', 'http_416'),
				417: this.intl.formatMsg('Expectation Failed', 'http_417'),
				418: this.intl.formatMsg('I\'m a teapot', 'http_418'),
				422: this.intl.formatMsg('Unprocessable Entity', 'http_422'),
				423: this.intl.formatMsg('Locked', 'http_423'),
				424: this.intl.formatMsg('Failed Dependency', 'http_424'),
				425: this.intl.formatMsg('Unordered Collection', 'http_425'),
				426: this.intl.formatMsg('Upgrade Required', 'http_426'),
				449: this.intl.formatMsg('Retry With', 'http_449'),
				450: this.intl.formatMsg('Blocked by Windows Parental Controls', 'http_450'),
				500: this.intl.formatMsg('Internal Server Error', 'http_500'),
				501: this.intl.formatMsg('Not Implemented', 'http_501'),
				502: this.intl.formatMsg('Bad Gateway', 'http_502'),
				503: this.intl.formatMsg('Service Unavailable', 'http_503'),
				504: this.intl.formatMsg('Gateway Timeout', 'http_504'),
				505: this.intl.formatMsg('HTTP Version Not Supported', 'http_505'),
				506: this.intl.formatMsg('Variant Also Negotiates', 'http_506'),
				507: this.intl.formatMsg('Insufficient Storage', 'http_507'),
				509: this.intl.formatMsg('Bandwidth Limit Exceeded', 'http_509'),
				510: this.intl.formatMsg('Not Extended', 'http_510')
			};
		}

		/**
   * _getClass - creates a class to use out of passed in response code.
   *
   * @param  {number} code response code
   * @return {string}	  class for use on the component.
   */

	}, {
		key: '_getClass',
		value: function _getClass(code) {
			var baseCode = Math.floor(code / 100) * 100;
			if (isNaN(baseCode)) {
				return '';
			}
			var returnClass = 'response-' + baseCode;
			if (baseCode !== code) {
				returnClass = returnClass + ' response-' + code;
			}
			return returnClass;
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    code = _props.code,
			    hasDescription = _props.hasDescription,
			    hasBackground = _props.hasBackground;

			var HTTP_CODES = this._getCodes();
			var className = this._getClass(code);
			if (hasDescription) {
				className += ' has-description';
			}
			if (hasBackground) {
				className += ' has-background';
			}
			var innerText = code;
			if (hasDescription && !!HTTP_CODES[code]) {
				innerText += ' ' + HTTP_CODES[code];
			}

			return _react2.default.createElement(
				'div',
				{ className: (0, _classnames2.default)('http-response-label', 'text-center', className) },
				_react2.default.createElement(
					'span',
					{ className: 'response' },
					innerText
				)
			);
		}
	}]);

	return HTTPResponseLabel;
}(_react2.default.Component);

/**
 * @property PropTypes
 * @description Property types supported by this component
 */


HTTPResponseLabel.propTypes = {
	code: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
	hasDescription: _propTypes2.default.bool,
	hasBackground: _propTypes2.default.bool
};

/**
 * @property DefaultProps
 * @description List of objects to incorporate into the context of this class
 */
HTTPResponseLabel.defaultProps = {
	hasDescription: true,
	hasBackground: false
};

var _default = (0, _reactIntl.injectIntl)(HTTPResponseLabel);

exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(HTTPResponseLabel, 'HTTPResponseLabel', 'src/components/HTTPResponseLabel.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/HTTPResponseLabel.jsx');
}();

;